import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ToastService } from "./toast.service";

@Injectable()
export class ClientPlanningCreationService {
  private single_url = `${environment.API_URL}/client-planning-creation`;
  private token = localStorage.getItem("token");
  private headers = new HttpHeaders().set("Authorization", `${this.token}`);

  constructor(private http: HttpClient, private toast: ToastService) {}

  submit(params) {
    return this.http
      .post(this.single_url, params, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        return response;
      });
  }

  checkToken(params) {
    let body = { planning_token: params };
    return this.http
      .post(this.single_url + "/checkToken", body, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        return response;
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/client-planning-creation.service.ts